<template>
    <div class="main-atv">
    <Breadcrumb :items="breadcrumbItems" />
    <FiltrosComponent
      :nomeTela="'parceria'"
      :filtrosIniciais="filtrosAtivos"
      :termoBuscaInicial="termoBusca"
      @aplicarFiltros="onAplicarFiltros"
      @pesquisar="onPesquisar"
    >
      <template #after-search>
        <div class="chips-container" role="group" aria-label="Filtro por área de atuação">
          <button
            v-for="area in areas"
            :key="area"
            class="chip"
            :class="{ ativo: filtrosAtivos.area === area }"
            :aria-pressed="filtrosAtivos.area === area"
            @click="selecionarArea(area)"
          >
            {{ area }}
          </button>
        </div>
      </template>
    </FiltrosComponent>
  </div>
  <div id="atividades" :class="{ 'single-item': parceriasFiltradas.length === 1 }">
    <div
      id="atividade"
      v-for="dadosParceria in parceriasFiltradas"
      :key="dadosParceria.id"
      @click="abrirParceria(dadosParceria.id)"
    >
      <div class="card">
        <img
          class="card-img-top"
          :src="dadosParceria.imagemUrl || imagemPadrao"
          :alt="dadosParceria.nome"
        />
    
        <div class="card-body">
          <div class="card-head">
            <h5>
              {{ dadosParceria.nome.toUpperCase() }}
            </h5>

            <p id="vagas">Parceiro: {{ dadosParceria.parceiro }}</p>

            <p>
              Área: {{ dadosParceria.area }}
            </p>
            <p>
              {{ dadosParceria.tipo }}
            </p>
          </div>

          <div id="descricao">
            <p class="card-text">
              <strong>Descrição:</strong>
              {{ limitarTexto(dadosParceria.descricao, 115) }}
            </p>
          </div>

          <div id="infos">
            <p class="card-text">Local: {{ dadosParceria.local }}</p>

            <p class="card-text">
              Data de Início: {{ formatarData(dadosParceria.dataInicio) }}
            </p>
          </div>
        </div>

        <div class="botoes">
          <button
            class="btn btn-primary inscrever"
            @click.stop="abrirParceria(dadosParceria.id)"
          >
            Saiba Mais
          </button>
        </div>
      </div>
    </div>
    <div>
      <h3 style="text-align: center" v-show="parceriasFiltradas.length === 0">
        Nenhuma Parceria encontrada
      </h3>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import Breadcrumb from "@/components/common/Breadcrumb.vue";
import FiltrosComponent from "@/components/common/FiltrosComponent.vue";
import imagemPadrao from "@/assets/logoGex_colorida.png";

const router = useRouter();
const route = useRoute();

const termoBusca = ref(route.query.q || "");
const filtrosAtivos = ref({
  dataInicial: route.query.dataInicial || "",
  dataFinal: route.query.dataFinal || "",
  local: route.query.local || null,
  area: route.query.area || "Todas",
});

const areas = [
  "Todas",
  "Comunicação",
  "Cultura",
  "Direitos Humanos e Justiça",
  "Educação",
  "Meio Ambiente",
  "Saúde",
  "Tecnologia e Produção",
  "Trabalho"
];

function selecionarArea(area) {
  filtrosAtivos.value.area = area;
}

function onAplicarFiltros(filtros) {
  filtrosAtivos.value = { ...filtrosAtivos.value, ...filtros };
}

function onPesquisar(termo) {
  termoBusca.value = termo;
}

function abrirParceria(id) {
  router.push({ name: "ParceriaView", params: { parceriaId: id } });
}

const breadcrumbItems = computed(() => {
  return [
    { label: "Início", to: "/" },
    { label: "Parcerias", to: `/Parcerias` },
  ];
});


const parceriasFiltradas = computed(() => {
  return todasParcerias.value.filter(parceria => {
    let matchTermo = true;
    let matchDataInicial = true;
    let matchDataFinal = true;
    let matchArea = true;
    let matchLocal = true;

    if (termoBusca.value) {
      const termoL = termoBusca.value.toLowerCase();
      matchTermo = 
        parceria.nome.toLowerCase().includes(termoL) || 
        parceria.parceiro.toLowerCase().includes(termoL) ||
        parceria.tipo.toLowerCase().includes(termoL) ||
        parceria.descricao.toLowerCase().includes(termoL);
    }

    if (filtrosAtivos.value.dataInicial) {
      const dInicio = new Date(parceria.dataInicio).getTime();
      const filtroDInicio = new Date(filtrosAtivos.value.dataInicial).getTime();
      if (dInicio < filtroDInicio) matchDataInicial = false;
    }

    if (filtrosAtivos.value.dataFinal) {
      const dInicio = new Date(parceria.dataInicio).getTime();
      const filtroDFinal = new Date(filtrosAtivos.value.dataFinal).getTime();
      if (dInicio > filtroDFinal) matchDataFinal = false;
    }
    
    if (filtrosAtivos.value.area && filtrosAtivos.value.area !== "Todas") {
      matchArea = parceria.area === filtrosAtivos.value.area;
    }

    if (filtrosAtivos.value.local) {
      matchLocal = parceria.local === filtrosAtivos.value.local;
    }

    return matchTermo && matchDataInicial && matchDataFinal && matchArea && matchLocal;
  });
});

// Dados Mockados para Parcerias
const todasParcerias = ref([
  {
    id: 1,
    nome: "Parceria com Empresa X",
    parceiro: "Empresa X",
    tipo: "Estágio",
    area: "Tecnologia e Produção",
    descricao:
      "Oportunidade de estágio remunerado na área de tecnologia para alunos dos cursos de TI. Vagas para desenvolvimento front-end e back-end.",
    local: "Campus do Pici (Fortaleza)",
    dataInicio: "2023-10-01T00:00:00",
    imagemUrl: null,
  },
  {
    id: 2,
    nome: "Programa de Trainee Y",
    parceiro: "Empresa Y",
    tipo: "Trainee",
    area: "Trabalho",
    descricao:
      "Programa de trainee voltado para recém-formados nas áreas de engenharia e administração. Foco em liderança.",
    local: "Campus do Benfica (Fortaleza)",
    dataInicio: "2024-01-15T00:00:00",
    imagemUrl: null,
  },
  {
    id: 3,
    nome: "Voluntariado ONG Z",
    parceiro: "ONG Z",
    tipo: "Voluntariado",
    area: "Educação",
    descricao:
      "Participe de ações sociais e projetos de impacto na comunidade local ensinando programação para jovens.",
    local: "Campus de Quixadá",
    dataInicio: "2023-08-20T00:00:00",
    imagemUrl: null,
  },
]);

function formatarData(dataStr) {
  if (!dataStr) return "";
  const data = new Date(dataStr);
  return data.toLocaleDateString("pt-BR");
}

function limitarTexto(texto, tamanho) {
  if (!texto) return "";
  if (texto.length <= tamanho) return texto;
  return texto.substring(0, tamanho) + "...";
}
</script>

<style scoped>
.main-atv {
  width: 100%;
}

.chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
  align-items: center;
}

.chip {
  padding: 6px 16px;
  border-radius: 9999px;
  border: 1px solid transparent;
  background-color: #f3f4f6;
  color: #374151;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.chip:hover {
  background-color: #e5e7eb;
}

.chip.ativo {
  background-color: var(--roxo-claro);
  color: var(--branco);
  border-color: var(--roxo-claro);
}

.chip.ativo:hover {
  opacity: 0.9;
}

.main-atv,
#atividades {
  width: 100% !important;
  max-width: none !important;
}

p {
  margin: 0;
}

#atividades {
  display: grid;
  grid-template-columns: repeat(2, minmax(560px, 1fr));
  gap: 1rem;
  justify-items: center;
  width: 100% !important;
  max-width: none !important;
}

#atividades.single-item {
  justify-items: start;
}

#atividade {
  display: flex;
  background-color: #ffffff;
  color: var(--preto);
  width: 100%;
  height: 235px;
  max-height: 235px;
  border-radius: 12px;
  cursor: pointer;
  border: 1.5px solid hsl(258, 30%, 90%);
  box-shadow: 0 4px 16px -2px rgba(54, 32, 101, 0.08), 0 2px 6px -1px rgba(54, 32, 101, 0.04);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

#atividade:hover {
  transform: translateY(-2px);
  border-color: hsl(258, 45%, 78%);
  box-shadow: 0 10px 24px -3px rgba(54, 32, 101, 0.14), 0 4px 10px -2px rgba(54, 32, 101, 0.06);
}

.card {
  background-color: transparent;
  overflow: hidden;
  border-radius: 12px;
  width: 100%;
  height: 235px;
  max-height: 235px;
  display: flex;
  align-items: stretch;
  flex-direction: row;
  gap: 12px;
  position: relative;
}

.card-img-top {
  width: 200px;
  min-width: 200px;
  max-width: 208px;
  height: 215px;
  max-height: 215px;
  object-fit: contain;
  background-color: #ffffff;
  margin-top: 10px;
  margin-left: 10px;
  border-radius: 8px;
  flex-shrink: 0;
  border: 1px solid hsl(258, 25%, 93%);
  padding: 5px;
}

.card-body {
  padding: 8px 12px 8px 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  height: 235px;
  max-height: 235px;
  gap: 5px;
  overflow: hidden;
}

.card-head {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex-shrink: 0;
}

h5 {
  font-size: 1.05rem;
  font-weight: 700;
  color: hsl(258, 53%, 22%);
  margin: 0 0 2px 0;
  line-height: 1.25;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-head p,
#infos p,
#descricao p {
  margin: 0;
  padding: 0;
  line-height: 1.38;
  font-size: 14px;
  color: hsl(258, 15%, 32%);
}

#descricao strong,
#vagas strong,
#infos strong {
  color: hsl(258, 40%, 25%);
}

#infos {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0;
  font-size: 14px;
  word-wrap: break-word;
  flex-shrink: 0;
}

#descricao {
  margin: 0;
  overflow: hidden;
  min-height: 0;
  flex-shrink: 1;
}

#descricao .card-text {
  margin: 0;
  font-size: 14px;
  line-height: 1.38;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}

.botoes {
  position: absolute;
  bottom: 10px;
  right: 10px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  z-index: 2;
}

.btn {
  font-size: 0.82rem;
  font-weight: 600;
  padding: 5px 14px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  user-select: none;
  line-height: 1.4;
  background-color: var(--roxo-claro);
  color: var(--branco);
}

.btn:hover {
  transform: translateY(-1px);
  background-color: hsl(278, 55%, 33%);
}
</style>
